import { Box, Typography, Stack, Avatar, Chip } from '@mui/material';
import { NAVY, GOLD_TEXT } from '../styles/ds';

/**
 * ZOHO-style hero header for detail pages.
 * Usage: <RecordHeader initials="AB" title="..." subtitle="..." chips={[...]} meta={[...]} actions={<>...</>} />
 * meta items: { label, value } objects displayed as a strip below the title.
 */
const RecordHeader = ({ initials, title, subtitle, chips = [], meta = [], actions }) => (
  <Box sx={{
    background: `linear-gradient(135deg, ${NAVY} 0%, #1a3260 100%)`,
    borderRadius: 3,
    p: 3,
    mb: 3,
    color: '#fff',
    boxShadow: '0 4px 24px rgba(13,29,62,0.18)',
  }}>
    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={2}>

      {/* Left: Avatar + Title */}
      <Stack direction="row" spacing={2.5} alignItems="center">
        <Avatar sx={{
          width: 60, height: 60,
          backgroundColor: 'rgba(200,169,110,0.22)',
          color: GOLD_TEXT,
          fontSize: 22, fontWeight: 700,
          border: `2px solid rgba(200,169,110,0.35)`,
        }}>
          {initials}
        </Avatar>
        <Box>
          <Typography variant="h5" fontWeight={700} lineHeight={1.2}>{title}</Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ opacity: 0.65, mt: 0.3 }}>{subtitle}</Typography>
          )}
          {chips.length > 0 && (
            <Stack direction="row" spacing={1} mt={1}>
              {chips.map((chip, i) => (
                <Chip key={i} label={chip.label} size="small" sx={{
                  backgroundColor: chip.bg || 'rgba(255,255,255,0.15)',
                  color: chip.color || '#fff',
                  fontWeight: 700,
                  fontSize: 11,
                  height: 22,
                }} />
              ))}
            </Stack>
          )}
        </Box>
      </Stack>

      {/* Right: Action buttons */}
      {actions && (
        <Stack direction="row" spacing={1} alignItems="center" flexShrink={0}>
          {actions}
        </Stack>
      )}
    </Stack>

    {/* Meta strip */}
    {meta.length > 0 && (
      <Stack direction="row" spacing={0} mt={2.5} flexWrap="wrap"
        divider={<Box sx={{ width: 1, backgroundColor: 'rgba(255,255,255,0.15)', mx: 2 }} />}>
        {meta.map((item, i) => (
          <Box key={i} sx={{ minWidth: 80 }}>
            <Typography variant="caption" sx={{ opacity: 0.55, display: 'block', fontSize: 10, letterSpacing: 0.5 }}>
              {item.label}
            </Typography>
            <Typography variant="body2" fontWeight={600} sx={{ mt: 0.2 }}>
              {item.value}
            </Typography>
          </Box>
        ))}
      </Stack>
    )}
  </Box>
);

export default RecordHeader;
